import { Component, OnInit } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AuthService } from './services/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  public selectedIndex: any = 0;
  public appPages = [
    {
      title: 'Curso',
      url: '/course',
      icon: 'albums'
    },
    {
      title: 'Sair',
      url: '/logout',
      icon: 'exit'
    },
  ];

  version = '0.0.19';
  vYear = new Date().getFullYear();

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public auth: AuthService,
    public navController: NavController,
    public router: Router,
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  ngOnInit() {
    const path = window.location.pathname.split('folder/')[1];
    if (path !== undefined) {
      this.selectedIndex = this.appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
    }

    this.routerNavigation();

  }

  routerNavigation() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)).subscribe((e: NavigationEnd) => {
        if (e.url == '/logout' || e.url == '/') {
          this.auth.logout();
        }
        if (e.url != undefined && e.url != null) {
          this.selectedIndex = !e.url.split('/')[1] ? e.url : '/' + e.url.split('/')[1];
        }
      });
  }

  go(url) {
    this.selectedIndex = url;

    if (url == '/logout') {
      this.auth.logout();
      url = '/';
    }

    this.navController.navigateRoot([url], { animated: true, animationDirection: 'forward' });
  }
}
